<template>
  <router-link :to="url">
    <div :class="classes" :style="styles"></div>

    <h3>
      {{ nominee.name }} <br>
      {{nominee.stations[0]}}
    </h3>
  </router-link>

</template>

<script>
import inViewport from '@/util/inViewport'
import throttle from '@/util/throttle'
import listen from '@/util/listen'

export default {
  name: 'NomineeItem',
  props: {
    nominee: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inViewport: false,
      listeners: []
    }
  },
  methods: {
    checkIfInViewport() {
      if (inViewport(this.$el, 10)) {
        const image = new Image()
        image.onload = () => {
          this.inViewport = true
        }
        image.src = this.nominee.image

        this.stopChecking()
      }
    },

    startChecking() {
      const checkIfInViewport = throttle(this.checkIfInViewport, 100)

      this.listeners = [
        listen(window, 'resize', checkIfInViewport),
        listen(document, 'scroll', checkIfInViewport)
      ]
    },

    stopChecking() {
      this.listeners.forEach(unlisten => unlisten())
      this.listeners = []
    }
  },

  mounted() {
    this.startChecking()
    this.checkIfInViewport()
  },

  beforeDestroy() {
    this.stopChecking()
  },

  computed: {
    ready() {
      return this.inViewport && this.nominee.image
    },

    classes() {
      return {
        item__body: true,
        'item__body--loaded': this.ready
      }
    },

    styles() {
      return this.ready
        ? {
            backgroundImage: `url(${this.nominee.image})`
          }
        : {}
    },

    url() {
      return {
        name: 'nominee',
        params: {
          categorySlug: this.category.slug,
          nomineeId: this.nominee.id,
          nomineeSlug: this.nominee.slug
        }
      }
    },

    channelTags() {
      return this.nominee.showtimes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NomineeItem.vue